import { Show } from 'solid-js'
import { useIntl } from '@cookbook/solid-intl'
import { useBannerMoleculeComponentController } from './banner-molecule-component-controller.jsx'
import './banner-molecule-component.scss'
import CustomSVG from '../../atoms/custom-svg.jsx'
import ButtonAtomComponent from '../../atoms/button-atom/button-atom-component.jsx'
import { messages } from './banner-molecule-component.messages.en.js'

export default function BannerMoleculeComponent (props) {
    const controller = useBannerMoleculeComponentController(props)
    const intl = useIntl()

    return (
        <div
            class={controller.rootClass()}
            {...controller.forwardedProps}
            onMouseEnter={controller.pauseTimer}
            onMouseLeave={controller.resumeTimer}
        >
            <div class="banner-molecule-component__main">
                <Show when={controller.icon && !controller.mergedProps.hideIcon}>
                    <div class="banner-molecule-component__icon">
                        {controller.icon()}
                    </div>
                </Show>

                <div class="banner-molecule-component__content">
                    <Show when={controller.mergedProps.header}>
                        <div class="banner-molecule-component__header">
                            {controller.mergedProps.header}
                        </div>
                    </Show>
                    <Show when={controller.mergedProps.body}>
                        <div class="banner-molecule-component__body">
                            {controller.mergedProps.body}
                        </div>
                    </Show>
                </div>

                <Show when={controller.mergedProps.layout === 'inline' && controller.mergedProps.inlineAction}>
                    <div class="banner-molecule-component__inline-action">
                        {controller.mergedProps.inlineAction}
                    </div>
                </Show>
                <Show
                    when={
                        controller.mergedProps.layout === 'inline'
                        && !controller.mergedProps.inlineAction
                        && controller.mergedProps.inlineActionText
                    }
                >
                    <div class="banner-molecule-component__inline-action">
                        <ButtonAtomComponent
                            class="banner-molecule-component__inline-action-button"
                            onClick={controller.mergedProps.onInlineActionClick}
                        >
                            {controller.mergedProps.inlineActionText}
                        </ButtonAtomComponent>
                    </div>
                </Show>

                <Show when={!controller.shouldHideCloseButton()}>
                    <ButtonAtomComponent
                        class="banner-molecule-component__close"
                        onClick={controller.mergedProps.onClose}
                        aria-label={intl.formatMessage(messages.closeAriaLabel)}
                    >
                        <CustomSVG path="icons/close-filled" />
                    </ButtonAtomComponent>
                </Show>
            </div>

            <Show when={controller.mergedProps.buttons && controller.mergedProps.layout !== 'inline'}>
                <div class="banner-molecule-component__buttons">
                    {controller.mergedProps.buttons}
                </div>
            </Show>

            <Show when={controller.mergedProps.autoDismissTimer}>
                <div
                    class="banner-molecule-component__progress-bar"
                    style={{
                        '--progress-duration': `${controller.mergedProps.autoDismissTimer}ms`,
                    }}
                />
            </Show>
        </div>
    )
}
